import React from "react";
import PropTypes from "prop-types";
import withStyles from "react-jss";
import { Tooltip, TooltipBody } from "ComponentsUI/Tooltip";

const styles = (theme) => ({
	root: {
		display: "flex",
		marginBottom: "5px",
		justifyContent: "space-between",
	},
	firstHalf: {
		width: "600px",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		textAlign: "center",
	},
	prov: {
		width: "250px",
		fontFamily: theme.fonts.medium,
		fontSize: "14px",
		lineHeight: "1.43",
		letterSpacing: "1.8px",
		color: theme.palette.colors.oneMoreGrey,
		textTransform: "uppercase",
		"& > span:first-child": {
			marginRight: "10px",
		},
	},
	tariff: {
		width: "120px",
		textAlign: "center",
		fontFamily: theme.fonts.medium,
		fontSize: "14px",
		lineHeight: "1.43",
		letterSpacing: "1.8px",
		color: theme.palette.colors.oneMoreGrey,
		textTransform: "uppercase",
	},
	rating: {
		width: "150px",
		textAlign: "center",
		fontFamily: theme.fonts.medium,
		fontSize: "14px",
		lineHeight: "1.43",
		letterSpacing: "1.8px",
		color: theme.palette.colors.oneMoreGrey,
		textTransform: "uppercase",
	},
	secondHalf: {
		width: "300px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	smiles: {
		width: "150px",
		display: "flex",
		justifyContent: "space-around",
		// marginRight: "20px",
		"& > div": {
			width: "50px",
			textAlign: "center",
			"& > img": {
				width: "25px",
				objectFit: "scale-down",
			},
		},
		"& > div:nth-child(1)": {
			marginLeft: "auto",
		},
		"& > div:nth-child(3)": {
			marginRight: "auto",
		},
	},
	positive: {
		cursor: "pointer",
	},
	neutral: {
		cursor: "pointer",
	},
	negative: {
		cursor: "pointer",
	},
	reviews: {
		width: "75px",
		textAlign: "center",
		// paddingLeft: "40px",
		// marginRight: "20px",
		"& > img": {
			width: "25px",
			objectFit: "scale-down",
		},
		cursor: "pointer",
	},
	comments: {
		width: "75px",
		textAlign: "center",
		// paddingLeft: "10px",
		"& > img": {
			width: "25px",
			objectFit: "scale-down",
		},
		cursor: "pointer",
	},
	button: {
		width: "180px",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		root: {
			marginBottom: "9px",
		},
		firstHalf: {
			width: "450px",
			alignItems: "flex-start",
		},
		prov: {
			width: "240px",
		},
		secondHalf: {
			width: "150px",
			alignItems: "flex-start",
		},
		rating: {
			width: "90px",
		},
		smiles: {
			width: "150px",
			marginRight: "0px",
			"& > div": {
				width: "50px",
			},
		},
		reviews: {
			display: "none",
			width: "100px",
			paddingLeft: "60px",
			marginRight: "0",
		},
		comments: {
			display: "none",
			width: "110px",
			paddingLeft: "60px",
		},
		button: {
			width: "180px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		firstHalf: {
			width: "350px",
			alignItems: "flex-start",
		},
		prov: {
			width: "180px",
		},
		tariff: {
			width: "65px",
		},
		rating: {
			width: "80px",
		},
		secondHalf: {
			width: "126px",
			alignItems: "flex-start",
		},
		smiles: {
			width: "126px",
			marginRight: "0px",
			"& > div": {
				width: "42px",
			},
		},
		reviews: {
			display: "none",
			width: "100px",
			paddingLeft: "60px",
			marginRight: "0",
		},
		comments: {
			display: "none",
			width: "80px",
			paddingLeft: "30px",
		},
		button: {
			width: "165px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			marginBottom: "9px",
		},
		firstHalf: {
			width: "50%",
			minWidth: "255px",
			flexGrow: "2",
		},
		rating: {
			width: "40%",
			textAlign: "right",
		},
		secondHalf: {
			width: "50%",
			flexGrow: "1",
			paddingLeft: "8.33%",
		},
		smiles: {
			width: "100%",
			display: "flex",
			marginRight: "0px",
			"& > div": {
				width: "33%",
			},
		},
		reviews: {
			display: "none",
		},
		comments: {
			display: "none",
		},
	},
	"@media (max-width: 520px)": {
		firstHalf: {
			width: "100%",
			minWidth: "0",
			flexGrow: "2",
		},
		rating: {
			width: "30%",
			textAlign: "right",
		},
		secondHalf: {
			display: "none",
		},
	},
});
const HeaderRowRating = ({
	classes,
	pos,
	name,
	TariffName,
	ratingName,
	ratingCount,
	positive,
	neutral,
	negative,
	reviews,
	comments,
	text,
	mainPage,
}) => {
	return (
		<div className={classes.root}>
			<div className={classes.firstHalf}>
				<div className={classes.prov}>
					{/*<span> {pos} </span>*/}
					<span> {name} </span>
				</div>
				<div className={classes.tariff}>{TariffName}</div>
				<div className={classes.rating}>
					<div>
						{ratingName} {ratingCount}
					</div>
				</div>
			</div>
			<div className={classes.secondHalf}>
				<div className={classes.smiles}>
					<Tooltip position={`top`} body={<TooltipBody> {text.REVIEWS_POSITIVE} </TooltipBody>}>
						<div className={classes.positive}>{positive}</div>
					</Tooltip>
					<Tooltip position={`top`} body={<TooltipBody> {text.REVIEWS_NEUTRAL} </TooltipBody>}>
						<div className={classes.neutral}>{neutral}</div>
					</Tooltip>
					<Tooltip position={`top`} body={<TooltipBody> {text.REVIEWS_NEGATIVE} </TooltipBody>}>
						<div className={classes.negative}>{negative}</div>
					</Tooltip>
				</div>
				<Tooltip position={`top`} body={<TooltipBody> {text.REVIEWS_All} </TooltipBody>}>
					<div className={classes.reviews}>{reviews}</div>
				</Tooltip>
				<Tooltip position={`top`} body={<TooltipBody> {text.COMMENTS} </TooltipBody>}>
					<div className={classes.comments}>{comments}</div>
				</Tooltip>
			</div>
			<div className={classes.button}>{null}</div>
		</div>
	);
};

HeaderRowRating.defaultProps = {
	pos: "",
	name: "",
	rating: "",
	positive: null,
	neutral: null,
	negative: null,
	reviews: null,
	comments: null,
	text: null,
};

HeaderRowRating.propTypes = {
	pos: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	rating: PropTypes.string.isRequired,
	positive: PropTypes.any.isRequired,
	neutral: PropTypes.any.isRequired,
	negative: PropTypes.any.isRequired,
	reviews: PropTypes.any.isRequired,
	comments: PropTypes.any.isRequired,
	text: PropTypes.any,
};

export default withStyles(styles)(HeaderRowRating);
